import { incrementLoader, decrementLoader } from "./loaderService";
import history from "../../shared/utils/history";
import { Component } from "ag-grid-community";
import ErrorScreen from "./ErrorScreen";
import { da } from "date-fns/locale";

// -------------------- API Fetch Wrapper --------------------
// -------------------- API Fetch Wrapper --------------------
export async function apiFetch(url, options = {}, config = {}) {
  const { showLoader = true } = config;

  if (showLoader) incrementLoader();

  try {
    const response = await fetch(url, options);
    return await handleResponse(response, url);
  } catch (err) {
    console.error("API Error:", err);
    return Promise.reject(err);
  } finally {
    if (showLoader) decrementLoader();
  }
}

// -------------------- Handle API Response --------------------
async function handleResponse(response, url) {
  let text = await response.text();
  let data;

  try {
    data = text ? JSON.parse(text) : null;
  } catch (e) {
    data = text;
  }

//   if (url.includes("/patientProfile") && response.status === 500) {
//     console.log("apifetch",data.errorMessages);
  
//   <ErrorScreen message={data?.errorMessages[0]} />; // return JSX
// }


  const token = response.headers.get("Authorization");

  console.warn("[AUTH-DIAG] API response", {
    url,
    status: response.status,
    time: new Date().toISOString(),
    tokenBeforeResponse: Boolean(localStorage.getItem("token")),
    refreshedTokenReceived: Boolean(token),
    refreshedTokenLength: token?.length || 0,
  });

  if (token) {
    localStorage.setItem("token", JSON.stringify(token));
  }

  if (data?.errorMessages?.length > 0 && url.includes("/patientProfile")) {
    const apiError = data.errorMessages[0]||"";
    return Promise.reject(apiError);
  }

  if (!response.ok) {
    // A failed login must be handled by the login screen. Auto-logout here
    // reloads the empty /Login route and hides the actual credential error.
    if (response.status === 401 && !url.includes("/auth/login")) {
      console.error("[AUTH-DIAG] 401 causing logout", {
        url,
        data,
        page: window.location.href,
        tokenPresent: Boolean(localStorage.getItem("token")),
        time: new Date().toISOString(),
      });
      logout(); // auto logout if 401 response returned from API
    }
    const error = data?.message || data?.errormsg || data?.errorMessages?.[0] || response.statusText;
    return Promise.reject(error);
  }
  return data;
}
// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  history.push("/");
  window.location.reload();
}
